import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import React from 'react';
import digital from '../../../assets/v2/Product/digital.svg';
import eld from '../../../assets/v2/Product/eld.svg';
import kioskdevice from '../../../assets/v2/Product/kioskdevice.svg';
import pos from '../../../assets/v2/Product/pos.svg';
import rugged from '../../../assets/v2/Product/rugged.svg';
import smartphone from '../../../assets/v2/Product/smartphone.svg';
import student from '../../../assets/v2/Product/student.svg';
import tablet from '../../../assets/v2/Product/tablet.svg';
import telehealth from '../../../assets/v2/Product/telehealth.svg';
import smartfitness from '../../../assets/v2/Product/smartfitness.svg';
import cloud from '../../../assets/v2/Product/cloud.svg';
import { navigate } from 'gatsby';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #03103b;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-bottom: 5rem !important;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 2rem;
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const SectionTwo = styled(SectionOne)`
  background-color: #232a57;
`;

const HeroImage = styled.div`
  display: grid;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  padding-bottom: 2rem;
`;

const ImgHolder = styled(LazyLoadImage)`
  height: fit-content;
  width: fit-content;
`;

const Heading = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  text-align: center;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;

const DevicesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  width: 100%;
  padding-top: 3rem;
`;

const DeviceItem = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: center;
  @media (max-width: 1200px) {
    grid-column: span 2;
    margin-bottom: 2rem;
  }

  @media (max-width: 520px) {
    grid-column: span 5;
    margin-bottom: 2rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
`;

const DeviceText = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  padding-top: 1rem;
  display: grid;
  align-items: start;
  min-height: 4rem;
`;

const SecondHeading = styled.div`
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #5cbd9a;
  padding-bottom: 3rem;
`;

const SecondContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-radius: 156.5px;
  background-color: #323f6d;
  padding: 2rem 6rem;
  width: 90%;
  @media (max-width: 800px) {
    border-radius: 10px;
  }
  @media (max-width: 520px) {
    padding: 3rem;
    width: 100%;
  }
`;

const ContainerItem = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: center;
  @media (max-width: 800px) {
    grid-column: span 2;
    margin-bottom: 2rem;
  }
  @media (max-width: 520px) {
    grid-column: span 4;
  }
`;

const ItemHeading = styled.div`
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;

  text-align: center;
  padding: 0 2rem;
  padding-bottom: 1rem;
  @media (min-width: 1600px) {
    padding: 0 3rem;
    padding-bottom: 1rem;
  }
  @media (max-width: 800px) {
    padding-bottom: 0.5rem;
  }
  @media (max-width: 350px) {
    padding: 0 1rem;
    padding-bottom: 0.5rem;
  }
`;

const ItemSubHeading = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #c2c9e3;
  text-align: center;
  padding: 0 2rem;
  @media (max-width: 800px) {
    padding: 0;
  }
`;

const BlueButtonNew = styled(BlueButton)`
  margin-top: 3rem;
  @media (max-width: 520px) {
    width: 12rem;
  }
`;
export default class ProductSectionFive extends React.Component<any, any> {
  render() {
    return (
      <div>
        <SectionOne>
          <HeroImage>
            <ImgHolder src={cloud} />
          </HeroImage>
          <Heading>
            {this.props?.messages?.HomePageAndroidDeviceTitle1}{' '}
            <span style={{ color: '#5cbd9a' }}>
              {this.props?.messages?.HomePageAndroidDeviceTitle2}{' '}
            </span>
            {this.props?.messages?.HomePageAndroidDeviceTitle3}
          </Heading>
          <SubHeading>
            {this.props?.messages?.HomePageAndroidDeviceDesc}
          </SubHeading>
          <DevicesContainer>
            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={kioskdevice} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceKiosk}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={rugged} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceRugged}
              </DeviceText>
            </DeviceItem>
            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={pos} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDevicePos}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={smartphone} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceSmartphone}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={tablet} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceTablet}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={telehealth} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceHealth}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={smartfitness} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceFitness}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder style={{ marginTop: '1.5rem' }} src={eld} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceELD}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={student} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceStudent}
              </DeviceText>
            </DeviceItem>

            <DeviceItem>
              <ImgWrapper>
                <ImgHolder src={digital} />
              </ImgWrapper>
              <DeviceText>
                {this.props?.messages?.HomePageAndroidDeviceSignage}
              </DeviceText>
            </DeviceItem>
          </DevicesContainer>
        </SectionOne>
        <SectionTwo>
          <SecondHeading>
            {this.props?.messages?.HomePageAndroidCompatibilityTitle}
          </SecondHeading>
          <SecondContainer>
            <ContainerItem>
              <ItemHeading>
                {this.props?.messages?.HomePageAndroidCompatibilitySupportAOSP}
              </ItemHeading>
              <ItemSubHeading>
                {this.props?.messages?.HomePageAndroidCompatibilityGMSnonGMS}
              </ItemSubHeading>
            </ContainerItem>
            <ContainerItem>
              <ItemHeading>
                {
                  this.props?.messages
                    ?.HomePageAndroidCompatibilityDeviceSupport
                }
              </ItemHeading>
              <ItemSubHeading>
                {this.props?.messages?.HomePageAndroidCompatibilityAndroidIOT}
              </ItemSubHeading>
            </ContainerItem>
            <ContainerItem>
              <ItemHeading>
                {this.props?.messages?.HomePageAndroidCompatibilityAllAndroid}
              </ItemHeading>
              <ItemSubHeading>
                {
                  this.props?.messages
                    ?.HomePageAndroidCompatibilityAndroidVersion
                }
              </ItemSubHeading>
            </ContainerItem>
            <ContainerItem>
              <ItemHeading>
                {this.props?.messages?.HomePageAndroidCompatibilityStreamlined}
              </ItemHeading>
              <ItemSubHeading>
                {this.props?.messages?.HomePageAndroidCompatibilityProvisioning}
              </ItemSubHeading>
            </ContainerItem>
          </SecondContainer>
          <BlueButtonNew
            id="product__request_demo"
            onClick={() =>
              navigate(
                this.props?.messages?.locale !== 'en'
                  ? `/${this.props?.messages?.locale}/book-demo`
                  : '/book-demo'
              )
            }
          >
            {this.props?.messages?.HomePageAndroidCompatibilityCTA}
          </BlueButtonNew>
        </SectionTwo>
      </div>
    );
  }
}
